/* eslint-disable no-magic-numbers */

const geoLocate = (lat1, lon1, lat2, lon2) => {
  // ‘Haversine’ formula to calculate distances between two points (latitude-longitude)
  const p = Math.PI / 180
  const c = Math.cos
  const earthRadius = 6371
  const a =
    0.5 -
    c((lat2 - lat1) * p) / 2 +
    (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2
  // c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p
  return 2 * earthRadius * Math.asin(Math.sqrt(a))
}

export const getNearestCentres = (userLat, userLon, centres) =>
  centres
    .map(centre => ({
      ...centre,
      distance: geoLocate(userLat, userLon, centre.latitude, centre.longitude),
    }))
    .sort((a, b) => a.distance - b.distance)

export default getNearestCentres
